// generated from 12 samples

import { z } from "zod";
import { common } from "../common";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const cardFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("card_filter"),
  comparison_key: z.enum([
    "7", // 10 (83.33%)
    "8", // 2 (16.67%)
  ]),
  display_name: z.string(),
  // undefined: 10 (83.33%), defined 2 (16.67%)
  raw_value: common.objectId.optional(),
  value: z.object({
    id: common.objectId,
    value: z.string(),
  }),
  varies_by_app_group: z.literal(true),
});
